module.exports = __webpack_public_path__ + "static/media/close.2146155c.svg";